import React from "react";
import { Route, Routes } from "react-router-dom";
import Sample_Report from "../all_reports/sample_report/Sample_Report";
import Instrument_Report from "../all_reports/instrument_report/Instrument_Report";
import Customer_Report from "../all_reports/customer_report/Customer_Report";
import Resource_Requirement from "../all_reports/resource_requirement/Resource_Requirement";
import Process_Requirement from "../all_reports/process_requirement/Process_Requirement";
import Quality_Control_Plan from "../all_reports/quality_control_plan/Quality_Control_Plan";
import Measurement_Uncertainty_Report from "../all_reports/measurement_uncertainty_report/Measurement_Uncertainty_Report";
import Ensuring_Validity_Of_Result from "../all_reports/ensuring_validity_of_result/Ensuring_Validity_Of_Result";
import Complaint_Report from "../all_reports/complaint_report/Complaint_Report";
import Non_Confirming_Repo from "../all_reports/non_confirming_repo/Non_Confirming_Repo";
import Management_System from "../all_reports/management_system/Management_System";
import External_Audit from "../all_reports/external_audit/External_Audit";

const Reports_Routes = () => {
  return (
    <Routes>
      <Route path="/sample-report" element={<Sample_Report />} />
      <Route path="/instrument-report" element={<Instrument_Report />} />
      <Route path="/customer-report" element={<Customer_Report />} />
      <Route path="/resource-requirement" element={<Resource_Requirement />} />
      <Route path="/process-requirement" element={<Process_Requirement />} />
      <Route path="/quality-control-plan" element={<Quality_Control_Plan />} />
      <Route path="/measurement-uncertainty-report" element={<Measurement_Uncertainty_Report />} />
      <Route path="/validity-result" element={<Ensuring_Validity_Of_Result />} />
      <Route path="/complaint-report" element={<Complaint_Report />} />
      <Route path="/non-confirming-work" element={<Non_Confirming_Repo />} />
      <Route path="/management-system" element={<Management_System />} />
      <Route path="/external-audit-report" element={<External_Audit />} />
    </Routes>
  );
};

export default Reports_Routes;
